import {
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<HasOnSuccess>;


export const DispatchInitalSubscriptionProduct: HandlerType = props => {
    props.dispatch({
        type: "Data/SubsriptionProductService/InitalValuesProduct",
    });
};

export const chain = [ DispatchInitalSubscriptionProduct];

const resetSubscribedProduct = createHandlerChainRunner(chain, "resetSubscribedProduct");
export default resetSubscribedProduct;
